import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../config/axiosConfig";

const Perfiles = () => {
  const [perfiles, setPerfiles] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPerfiles();
  }, []);

  const fetchPerfiles = async () => {
    try {
      const { data } = await axiosInstance.get("/perfiles/lista");
      setPerfiles(data.data);
    } catch (error) {
      console.error("Error al obtener perfiles", error);
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow">
        <div className="card-header">
          <h4 className="mb-0">Perfiles</h4>
        </div>
        <div className="card-body">
          <button className="btn btn-primary mb-3" onClick={() => navigate("/perfiles/nuevo")}>
            Nuevo Perfil
          </button>
          <table className="table table-striped">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nombre</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {perfiles.map((perfil) => (
                <tr key={perfil.id}>
                  <td>{perfil.id}</td>
                  <td>{perfil.nombre}</td>
                  <td>
                    <button className="btn btn-primary btn-sm" onClick={() => navigate(`/perfiles/${perfil.id}`)}>
                      Editar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Perfiles;
